import React from 'react';
import { Box, Button, Typography, CircularProgress } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Container } from '@/components/common';

/**
 * 로딩 상태 컴포넌트
 * 
 * 데이터를 불러오는 중일 때 표시되는 컴포넌트입니다.
 * 
 * @param {string} title - 페이지 제목
 */
export const LoadingState = ({ title = '로딩 중' }) => {
  return (
    <Container title={title}>
      <Box display='flex' justifyContent='center' alignItems='center' minHeight='400px'>
        <CircularProgress />
      </Box>
    </Container>
  );
};

/**
 * 에러 상태 컴포넌트
 * 
 * 데이터를 불러오는 중 오류가 발생했을 때 표시되는 컴포넌트입니다.
 * 
 * @param {string} title - 페이지 제목
 * @param {string} message - 에러 메시지
 * @param {Function} onGoBack - 뒤로가기 핸들러
 */
export const ErrorState = ({ title = '오류', message = '정보를 불러오는 중 오류가 발생했습니다.', onGoBack }) => {
  return (
    <Container title={title}>
      <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' minHeight='400px' gap={2}>
        <Typography variant='h6' color='error'>
          {message}
        </Typography>
        {onGoBack && (
          <Button variant='outlined' onClick={onGoBack} startIcon={<ArrowBackIcon />}>
            목록으로 돌아가기
          </Button>
        )}
      </Box>
    </Container>
  );
};

/**
 * 데이터 없음 상태 컴포넌트
 * 
 * 데이터를 찾을 수 없을 때 표시되는 컴포넌트입니다.
 * 
 * @param {string} title - 페이지 제목
 * @param {string} message - 메시지
 * @param {Function} onGoBack - 뒤로가기 핸들러
 */
export const EmptyState = ({ title = '데이터 없음', message = '정보를 찾을 수 없습니다.', onGoBack }) => {
  return (
    <Container title={title}>
      <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' minHeight='400px' gap={2}>
        <Typography variant='h6'>{message}</Typography>
        {onGoBack && (
          <Button variant='outlined' onClick={onGoBack} startIcon={<ArrowBackIcon />}>
            목록으로 돌아가기
          </Button>
        )}
      </Box>
    </Container>
  );
};
